var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelUpcoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-upcoming_svg__a",
    x1: "76.234%",
    x2: "18.187%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#202E4A",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-upcoming_svg__a)",
    d: "M9.744 5.625h9.431a2.2 2.2 0 012.2 2.2V22.5h0-13.83V7.825a2.2 2.2 0 012.2-2.2z",
    transform: "translate(1.875 1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    d: "M14.151 13h5.029m-5.029 3.375h5.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.075 1.75h9.43a2.2 2.2 0 012.2 2.2v20.3h0-13.83V3.95a2.2 2.2 0 012.2-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.005 18.625h1.57a1.1 1.1 0 011.1 1.1v4.525h0-3.77v-4.525a1.1 1.1 0 011.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    d: "M6.276 7.375h5.029M6.276 10.75h5.029m-5.029 3.375h5.029"
  }))));
}
export default SvgHotelUpcoming;